import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { AuthenticationService } from './services/authentication.service';
import { CashBookingService } from './services/cashbooking.service';
import { environment } from 'src/environments/environment';
// @HostListener("window:onbeforeunload", ["$event"])
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'AED';
  // public validinput = "^(?:[^()]*|[^()]*\([^()]*\)[^()]*)$";
  public validinput: RegExp = /^[^\s]+(\s+[^\s]+)*$/;
  constructor(dateTimeAdapter: DateTimeAdapter<any>,
    private router: Router,
    private cashBookingService: CashBookingService) {
    dateTimeAdapter.setLocale('en-in');
  }

  ngOnInit(): void {

    if (environment.production) {
      if (location.protocol !== 'https:') {
        location.replace(`https:${location.href.substring(location.protocol.length)}`);
      }
    }
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        if (e.url === '/devices' || e.url === '/tripreport' || e.url === '/dailyreport'
          || e.url === '/weeklyreport' || e.url === '/monthlyreport' || e.url === '/outturnreport'
          || e.url === '/tripsimulationreport' || e.url.startsWith('/tripsimulationreport')
          || e.url === '/evaadagaidashboard' || e.url.startsWith('/evaadagaidashboard')
          || e.url === '/banksettlements' || e.url.startsWith('/banksettlements')
          || e.url === '/poolaccounttransfer' || e.url.startsWith('/poolaccounttransfer')
          || e.url === '/treasurytransfer' || e.url.startsWith('/treasurytransfer')
          || e.url === '/machineryallocate' || e.url.startsWith('/machineryallocate')
          || e.url === '/cashbooking' || e.url.startsWith('/cashbooking')
          || e.url === '/departmentbooking' || e.url.startsWith('/departmentbooking')
          || e.url === '/mhiredemo' || e.url.startsWith('/mhiredemo')
          || e.url === '/refundapproval' || e.url.startsWith('/refundapproval')
          || e.url === '/mhirelogbook' || e.url.startsWith('/mhirelogbook')
          || e.url.startsWith('/realtimecharts')
          || e.url.startsWith('/serviceschedules')
          || e.url.startsWith('/targets/')
          || e.url.startsWith('/tariffs/')
          || e.url.startsWith('/regions') || e.url.startsWith('/regions') || e.url.startsWith('/divisions')
          || e.url.startsWith('/subdivisions') || e.url.startsWith('/consumables') || e.url.startsWith('/workshops')
          || e.url.startsWith('/providers')
          || e.url.startsWith('/users/')
          || e.url.startsWith('/users')
          // || e.url.startsWith('/devices/')
          || e.url.startsWith('/vehicles/')
          || e.url.startsWith('/implements/')
          || e.url.startsWith('/drivers/')
          || e.url.startsWith('/fuellog/')
          || e.url.startsWith('/tripentries/')
          || e.url.startsWith('/servicelog/')
          || e.url.startsWith('/consumableentries/')
          || e.url.startsWith('/expenseentries/')
          || e.url.startsWith('/machineryallocate/')
          || e.url.startsWith('/cashbooking/')
          || e.url.startsWith('/mhirelogbook/')
          || e.url.startsWith('/news')
          || e.url.startsWith('/scheme')
          || e.url.startsWith('/terms')
          || e.url.startsWith('/vehiclecategory')
          || e.url.startsWith('/Implement')
          || e.url.startsWith('/mfdashboard')
          || e.url.startsWith('/dealer')
          || e.url.startsWith('/product')
          || e.url.startsWith('/dealerproductmapping')
          || e.url.startsWith('/manufacturer')
          || e.url.startsWith('/profile')
          || e.url.startsWith('/hodashboard')
          || e.url.startsWith('/manufacturerlist')
          || e.url.startsWith('/dealerlist')
          || e.url.startsWith('/farmerlist')
          || e.url.startsWith('/statetarget')
          || e.url.startsWith('/subdivisiontarget')
          || e.url.startsWith('/divisiontarget')
          || e.url.startsWith('/villagetarget')
          || e.url.startsWith('/divisionleveltarget')
          || e.url.startsWith('/subdivisiontargetlist')
          || e.url.startsWith('/villageleveltarget')
          || e.url.startsWith('/statetargetlist')
          || e.url.startsWith('/targetset')
          || e.url.startsWith('/targetapproval')
          || e.url.startsWith('/utilizationreport')
          || e.url.startsWith('/districtwisestatusreport')
          || e.url.startsWith('/districtwisemachineryaddedreport')
          || e.url.startsWith('/paccsdistrictmachinaryreport')
          || e.url.startsWith('/paccsblockwisemachinarystatusreport')
          || e.url.startsWith('/viewfarmer')
          || e.url.startsWith('/farmer')
          || e.url.startsWith('/eefarmerbookingapproval')
          || e.url.startsWith('/aeefarmerbooking')
          || e.url.startsWith('/ViewmanufacturerbookingDetails')
          || e.url.startsWith('/aefarmerbooking')
          || e.url.startsWith('/divisionnew')
          || e.url.startsWith('/mechanizationreport')
          || e.url.startsWith('/dbtbookingreport')
          || e.url.startsWith('/reviewreport')
          || e.url.startsWith('/regionwisereviewreport')
          || e.url.startsWith('/beneficiaryreport')
          || e.url.startsWith('/bookingreport')
          || e.url.startsWith('/treasuryremittedreport')
          || e.url.startsWith('/toberemittedintreasuryreport')
          || e.url.startsWith('/billreport')
          || e.url.startsWith('/models')
          || e.url.startsWith('/models/')
          || e.url.startsWith('/viilagewisereport')
          || e.url.startsWith('/smamdashboard')

          || e.url.startsWith('/divisionwisereport')
          || e.url.startsWith('/subdivisionwisereport')
          || e.url.startsWith('/districtwisereport')
          || e.url.startsWith('/districtwithsubdivisionwisereport')
          || e.url.startsWith('/divisionwithsubdivisionwisetargetreport')
          || e.url.startsWith('/subdivisionwiseflowprogressreport')
          || e.url.startsWith('/divisionwisetargetreport')
          || e.url.startsWith('/onlinereceipts')
          || e.url.startsWith('/cashreceipts')
          || e.url.startsWith('/departmentreceipts')
          || e.url.startsWith('/blockvillagemaping')
          || e.url.startsWith('/machinerywisereport')
          || e.url.startsWith('/vehicleorder')
          || e.url.startsWith('/waitinglistreport')
          || e.url.startsWith('/bankname')
          || e.url.startsWith('/bankname/')
          || e.url.startsWith('/bankcity/')
          || e.url.startsWith('/bankcity')
          || e.url.startsWith('/bankbranch')
          || e.url.startsWith('/beneficiarydetailreport')
          || e.url.startsWith('/paccsbooking')
          || e.url.startsWith('/paccsbooking/')
          || e.url.startsWith('/paccsdashboard')
          || e.url.startsWith('/paccswisereport')
          || e.url.startsWith('/paccswisedialyreport')
          || e.url.startsWith('/paccsinfo')
          || e.url.startsWith('/paccsusers')
          || e.url.startsWith('/divisionwiseutilizationreport')
            || e.url.startsWith('/subsidyschemestatusreport')
            || e.url.startsWith('/pvtblockwisestatusreport')
            || e.url.startsWith('/pvtsubdivisionstatusreport')
            || e.url.startsWith('/farmercultivationdetailsreport')
            || e.url.startsWith('/pvtblockwisemachinarystatusreport')
            || e.url.startsWith('/paccsblockmachinaryreport')
            || e.url.startsWith('/districtwiseimplementreport')
            || e.url.startsWith('/paccsdistrictwiseimplementreport')
            || e.url.startsWith('/paccswiseprogressreport')
            || e.url.startsWith('/districtwisepaccsprogressreport')
            || e.url.startsWith('/makkaludanmudhalvarschemecampreport')
            || e.url.startsWith('/logbookreport')
            || e.url.startsWith('/pendencyreport')
            || e.url.startsWith('/paccsimplementreport')

            || e.url.startsWith('/pvtmachinery')
            || e.url.startsWith('/pvtbooking')
            || e.url.startsWith('/paccsbookingdetailsreport')
            || e.url.startsWith('/pvtimplement')
            || e.url.startsWith('/serviceprovider')
            || e.url.startsWith('/pvtevaadagaidashboard')
            || e.url.startsWith('/bookingstatusreport')
            || e.url.startsWith('/PVTServiceProvidersStatusReport')
            || e.url.startsWith('/paccsregistrationstatusreport')
            || e.url.startsWith('/e2emechanizationreport')
            || e.url.startsWith('/e2eschemeprogressreport')
            || e.url.startsWith('/pendencyreport')
            || e.url.startsWith('/bookingdetailreport')
            || e.url.startsWith('/spstatusreport')
            || e.url.startsWith('/paccsstatusdetailsreport')
            || e.url.startsWith('/payout')
            || e.url.startsWith('/pvtonlinereceipt')
            || e.url.startsWith('/devicelog')
            || e.url.startsWith('/machinaryclasification')
            || e.url.startsWith('/machinarycategory')
            || e.url.startsWith('/powersource')
            || e.url.startsWith('/specdbtproduct')
            || e.url.startsWith('/componentdbtproduct')
            || e.url.startsWith('/financialyear')
            || e.url.startsWith('/department')
            || e.url.startsWith('/dbtgo')
            || e.url.startsWith('/dbtscheme')
            || e.url.startsWith('/dbtcomponent')
            || e.url.startsWith('/schemedbtgo')
            || e.url.startsWith('/dbtproduct')
            || e.url.startsWith('/configdbtproduct')
            || e.url.startsWith('/subsidydbtproduct')
            || e.url.startsWith('/pvtpendencyreport')
            || e.url.startsWith('/dbtproductconfig')
            || e.url.startsWith('/dbtproductsubsidy')
            || e.url.startsWith('/gramapanchayat')
            || e.url.startsWith('/dbtwaitinglistreport')
            || e.url.startsWith('/implementscategory')
            || e.url.startsWith('/summarydivisionwiseutilizationreport')
            || e.url.startsWith('/spregistrationsummaryreport')
            || e.url.startsWith('/paccsbookingstatusreport')
            || e.url.startsWith('/e2efarmerdetails')
            || e.url.startsWith('/e2eEntrepreneurdetails')
            || e.url.startsWith('/e2edashboard')
            || e.url.startsWith('/blockLevelTarget')
            || e.url.startsWith('/e2eCropMaster')
            || e.url.startsWith('/paccsserviceprovider')
            || e.url.startsWith('/divisionLevelTarget')
            || e.url.startsWith('/paccspayout')
            || e.url.startsWith('/paccsonlinereceipt')
            || e.url.startsWith('/psbooking')
            || e.url.startsWith('/psevaadagaidashboard')
            || e.url.startsWith('/ticketingsystem')
            || e.url.startsWith('/paccsevaadagairegionwisereport')
            || e.url.startsWith('/paccsdetailregionwisereport')
            || e.url.startsWith('/paccsduplicate')
            || e.url.startsWith('/ticketforwardusermapping')
            || e.url.startsWith('/runlottery')
            || e.url.startsWith('/lotterydashboard')
            || e.url.startsWith('/lotteryreport')
            || e.url.startsWith('/lotterybeneficiarylist')
            || e.url.startsWith('/lotteryvillage')
            || e.url.startsWith('/lotterysubdivision')
            || e.url.startsWith('/lotterydetails')
            || e.url.startsWith('/lotterybookingdetails')
            || e.url.startsWith('/machinerystatusreport')




                       







        ) {
          document.body.classList.add('removeglobalfilter');


        } else {
          document.body.classList.remove('removeglobalfilter');

        }
      }


      if (e instanceof NavigationEnd) {
        if (e.url.startsWith('/implements')) {
          document.body.classList.add('removeblockfilter');

          document.body.classList.remove('removecolumnfilter');


        } else {
          document.body.classList.remove('removeblockfilter');
          document.body.classList.add('removecolumnfilter');


        }
      }

    });
    // this.getMarqueeData();
  }
  getMarqueeData() {
    let data = {
      'key': '',
      // langType: this.language
    }
    this.cashBookingService.getMarqueeData(data, true).subscribe(res => {
      if (res) {

      }
    })
  }

  clearAllData() {
    // this.authService.logOut();
  }

}
